import { type ReactNode } from 'react';
import { Spinner } from '@/components/ui/spinner';
import { EmptyState } from '@/components/ui/empty-state';
import type { Creator } from '@/types';
import { CreatorsTable } from './creators-table';

type ListResult = { items: Creator[]; totalPages: number; totalItems: number };

type Props = {
  state: 'loading' | 'data' | 'empty';
  data: ListResult | undefined;
  isFetching: boolean;
  onSelect: (id: string) => void;
};

export function CreatorsContent({
  state,
  data,
  isFetching,
  onSelect,
}: Props): ReactNode {
  if (state === 'loading') return <Spinner />;
  if (state === 'empty') return <EmptyState title="Sin resultados" />;
  return (
    <CreatorsTable
      creators={data?.items ?? []}
      totalPages={data?.totalPages ?? 1}
      totalItems={data?.totalItems ?? 0}
      isFetching={isFetching}
      onSelect={onSelect}
    />
  );
}
